import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from '@phoenix/i18n';
import { useColorMode } from '../theme/colorMode';

/** تعویض روشن و تیره. انتخاب در ترجیح ظاهر ذخیره می‌شود. */
export function ColorModeToggle() {
  const { t } = useTranslation('common');
  const { mode, setMode } = useColorMode();
  const dark = mode === 'dark';
  const label = t(dark ? 'common:shell.use_light' : 'common:shell.use_dark');

  return (
    <Tooltip title={label}>
      <IconButton color="inherit" aria-label={label} aria-pressed={dark} data-testid="color-mode-toggle" onClick={() => setMode(dark ? 'light' : 'dark')}>
        {dark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
}
